export const home = {
  homeHerder: {
    title1: "首页",
    title2: "任务中心",
    title3: "积分兑换",
    title4: "活动中心",
    title5: "帮助中心",
    title6: "商务合作",
    title7: "登录",
    title8: "注册",
    title9: "退出登录",
  },
  mobileHerder: [
    {
      name: "首页",
      type: 1,
      path: "/home",
    },
    {
      name: "首页",
      type: 2,
      children: [
        {
          name: "我的首页",
          path: "/module/home",
        },
        {
          name: "任务记录",
          path: "/module/taskRecord",
        },
        {
          name: "兑换历史",
          path: "/module/redemptionHistory",
        },
        {
          name: "金币明细",
          path: "/module/goldHistory",
        },
        {
          name: "账户设置",
          path: "/module/account",
        },
        {
          name: "我的邀请",
          path: "/module/invite",
        },
        {
          name: "我的信用值",
          path: "/module/creditValue",
        },
      ],
    },
    {
      name: "任务",
      type: 3,
      path: "/module/task",
    },
    {
      name: "兑换",
      type: 3,
      path: "/module/exchange",
    },
    {
      name: "活动",
      type: 3,
      path: "/module/activity",
    },
    {
      name: "帮助",
      type: 3,
      path: "/module/help",
    },
    {
      name: "登录/注册",
      path: "/login",
      type: 3,
    },
    {
      name: "退出登录",
      path: "/login",
      type: 3,
    },
  ],
  mobileHerder2: [
    {
      name: "首页",
      path: "/home",
    },
    {
      name: "任务",
      path: "/module/task",
    },
    {
      name: "兑换",
      path: "/module/exchange",
    },
    {
      name: "活动",
      path: "/module/activity",
    },
    {
      name: "帮助",
      path: "/module/help",
    },
    {
      name: "商务",
      path: "/commerce",
    },
    {
      name: "登录/注册",
      path: "/login",
    },
  ],
  page1: {
    title1: "分享新的观点",
    title2: "助力美好生活",
    title3:
      "“爱答卷”是一个调研任务有偿参与平台，你可以通过微信公众号、电脑访问我们，参与调研任务并获得现金回报，已累计发布97000+个调研任务，发放55000万+奖励",
    title4: "了解更多",
  },
  page2: {
    title1: "如何获得奖励",
    tips1: "爱答卷，轻松三步走，现金红包拿不停",
    boxs1: {
      title1: "注册加入",
      title2: "完善资料才能有更多任务等你参与",
    },
    boxs2: {
      title1: "参与任务",
      title2: "幸运任务/日常任务随你做",
    },
    boxs3: {
      title1: "兑换奖励",
      title2: "微信红包/支付宝红包任你换",
    },
  },
  page5: {
    title1: "他们正在使用爱答卷",
    tips1: "爱答卷，现金红包拿不停",
    boxs1: "已累计发布调研任务",
    boxs2: "已累计发布调研任务",
    boxs3: "已累计发放现金奖励",
  },
  footer: {
    title1: "加入爱答卷，参与问卷调研，释放你的影响力！",
    title2: "开始答卷",
    title3: "关于爱答卷",
    title4: "公司",
    title5: "关于我们",
    title6: "加入我们",
    title7: "支持",
    title8: "帮助中心",
    title9: "商务合作",
    title10: "关于",
    title11: "服务协议",
    title12: "隐私政策",
    title13: "免责声明",
    title14: "微信客服",
    title15: "联系方式",
  },
};
